<div class="page-container unified container launcher-container">
  @if (!loading && unitLandingPage) {
    <div class="apps mb-4">
      <div class="buttons-container mb-3">
        <div class="apps-container">
          @for (app of apps; track app) {
            @if (
              setUpLandingPage &&
              setUpLandingPage['Show' + app + 'CreateCaseButton']
            ) {
              @if (showCopyPrompt) {
                <button
                  type="button"
                  class="app-button"
                  [matMenuTriggerFor]="copyCaseMenu"
                  [ngClass]="{
                    disabled:
                      !unitLandingPage[app + 'StartButtonActive'] ||
                      disableButtons,
                  }"
                >
                  @if (showOneAppView) {
                    <div class="single-app-icon">
                      <mat-icon>post_add</mat-icon>
                    </div>
                    <div class="single-app-text"> RightBRIDGE </div>
                  } @else {
                    <mat-icon [svgIcon]="app.toLowerCase() + '_icon'" />
                    @if (moduleLabels[app]) {
                      <div class="mt-2"> {{ moduleLabels[app] }} </div>
                    }
                  }
                  <div class="app-button-text mt-2">
                    {{ unitLandingPage[app + 'StartButtonText'] }}
                  </div>
                </button>

                <mat-menu #copyCaseMenu="matMenu" class="app-button-menu">
                  <button
                    type="button"
                    mat-menu-item
                    (click)="goToQuestionnaire(app.toLowerCase())"
                  >
                    <mat-icon>add_circle_outline</mat-icon> New
                  </button>
                  <button
                    type="button"
                    mat-menu-item
                    (click)="copyCase(app.toLowerCase())"
                  >
                    <mat-icon>folder_copy</mat-icon> Copy Existing
                  </button>
                  @if (
                    app.toLowerCase() === 'pp' &&
                    rights.includes('AIChatbotOnHomeScreen')
                  ) {
                    <button
                      type="button"
                      mat-menu-item
                      (click)="goToPage('rb-chatbot')"
                    >
                      <mat-icon>folder_copy</mat-icon> Use AI Assistant
                    </button>
                  }
                </mat-menu>
              } @else {
                <button
                  type="button"
                  class="app-button disabled"
                  [ngClass]="{
                    disabled:
                      !unitLandingPage[app + 'StartButtonActive'] ||
                      disableButtons,
                  }"
                  (click)="goToQuestionnaire(app.toLowerCase())"
                >
                  @if (showOneAppView) {
                    <div class="single-app-icon">
                      <mat-icon>post_add</mat-icon>
                    </div>
                    <div class="single-app-text"> RightBRIDGE </div>
                  } @else {
                    <mat-icon [svgIcon]="app.toLowerCase() + '_icon'" />
                    @if (moduleLabels[app]) {
                      <div class="mt-2">
                        {{ moduleLabels[app] }}
                      </div>
                    }
                  }
                  <div class="app-button-text mt-2">
                    {{ unitLandingPage[app + 'StartButtonText'] }}
                  </div>
                </button>
              }
            }
          }
        </div>
        <div class="buttons-container-bottom-border"></div>
      </div>

      <div class="actions">
        @if (unitLandingPage && !unitLandingPage.HideExistingCaseButton) {
          <button
            type="button"
            class="existing-button"
            (click)="goToPage('/search')"
          >
            <mat-icon>search</mat-icon> Select Existing Case
            <div class="actions-container-bottom-border"></div>
          </button>
        }
      </div>
    </div>
  }

  <div class="resources w-100 row">
    @if (unitToolsCheck()) {
      <div class="tools col-12 {{ toolsWidthCheck(true) }}">
        @if (!loading) {
          @for (app of apps; track app) {
            @if (
              unitTools[app + 'UnitTools'] &&
              unitTools[app + 'UnitTools'].length > 0
            ) {
              <div class="unit-tools-container col-12 {{ toolsWidthCheck() }}">
                <h4>{{
                  unitToolsHeaders[app + 'Title'] ||
                    defaultTitle(app) + ' Tools'
                }}</h4>

                @if (unitToolsHeaders[app + 'Description']) {
                  <p>{{ unitToolsHeaders[app + 'Description'] }}</p>
                }

                <div class="unit-tools-list">
                  @for (
                    tool of unitTools[app + 'UnitTools'];
                    track i;
                    let i = $index
                  ) {
                    @if (!tool.ToolExternal) {
                      <app-tool-link
                        [tooltip]="tool.ToolDescription"
                        [toolLabel]="tool.ToolName"
                        (defaultClick)="
                          onInternalLink(tool.ToolLink, tool.ToolName)
                        "
                      />
                    } @else {
                      <app-tool-link
                        [tooltip]="tool.ToolDescription"
                        [toolLabel]="tool.ToolName"
                        [externalLink]="tool.ToolLink"
                      />
                    }
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    }

    @if (unitLandingPage && unitLandingPage.GeneralDescriptionShow) {
      <div
        class="landing-description-container"
        [ngClass]="unitToolsCheck() ? 'col-md-3' : 'col-12'"
      >
        <div
          class="landing-description"
          [innerHTML]="unitLandingPage.GeneralDescriptionText"
        ></div>
      </div>
    }
  </div>

  <app-background-decoration />
</div>
